import { Injectable } from "@angular/core";
import { ContractsService } from "../contracts.service";
import { Web3Service } from "app/services/web3/web3.service";
import { eContracts } from "../contract.config";
import { Observable, of, switchMap } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MerkleMBService {

    public contract: any
    public contractTwo:any
    public contractThree:any

    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        this.contract = this.contractsService.getContract(eContracts.MerkleMB);
        this.contractTwo = this.contractsService.getContract(eContracts.MerkleMBTwo);
        this.contractThree = this.contractsService.getContract(eContracts.MerkleMBThree);
    }

    paymentToken(): Observable<string> {
        return of(this.contract.methods.paymentToken().call());
    }
    paymentTokenTwo(): Observable<string> {
        return of(this.contractTwo.methods.paymentToken().call());
    }
    paymentTokenThree(): Observable<string> {
        return of(this.contractThree.methods.paymentToken().call());
    }

}